import styled from 'styled-components'

import { Accordion } from '@interco/inter-ui/components/Accordion'
import IcChevronDown from '@interco/icons/core/action-navigation/ic_chevron_down'

export const QuestionArea = styled.button<{ $isExpanded: boolean }>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 0.5rem;
  background-color: transparent;

  span {
    flex: 1;
    margin: auto;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${(props) => (props.$isExpanded ? 'none' : '2')};
    color: var(--typography500);
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    transition: max-height 0.3s linear;

    &.contracted {
      max-height: 40px;
    }

    &.expanded {
      max-height: 90px;
    }
  }

  .up {
    transform: rotate(180deg);
  }

  .down {
    transform: rotate(0deg);
  }
`

export const ChevronDown = styled(IcChevronDown)`
  min-width: 2rem;
  min-height: 2rem;
  padding: 0.25rem;
  transition: all 0.3s ease-out;
`

export const FrequentQuestionsAccordion = styled(Accordion)`
  background-color: transparent;
  padding: 1rem 0;
  border-bottom: 1px solid var(--gray200);
  border-radius: 0;
  user-select: none;

  .max-lines {
    transition: max-height 0.3s linear;
  }

  .test.ellipsis::after {
    content: '...';
  }

  &:first-of-type {
    padding-top: 0.25rem;
  }

  div[role='region'] > div {
    padding: 1rem 0;
  }
`

export const Clickable = styled.div`
  user-select: none;

  &::selection {
    background-color: transparent;
    color: transparent;
  }
`
